import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportRoutingModule } from './report-routing.module';
import { EmergencyCommandComponent } from './emergencyCommand/emergency-command.component';
import { EmergencyPositionComponent } from './emergencyPosition/emergency-position.component';

@NgModule({
  declarations: [EmergencyCommandComponent, EmergencyPositionComponent],
  imports: [
    CommonModule,
    ReportRoutingModule,
    NgbTooltipModule,
    NgbPopoverModule,
    SharedModule,
  ],
})
export class ReportModule {}
